import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'
import { Group } from '@/types/group'

import { IAction } from '../actions/action-helpers'
import { DepartmentsTypes } from '../actions/actions.types'

type DepartmentsState = ApplicationState['departments']

function departmentsReducer(state: DepartmentsState = new ImmutableMap(), action: IAction): DepartmentsState {
	switch (action.type) {
		case DepartmentsTypes.GetAllDepartments.SUCCESS:
			return (action.payload ?? []).reduce(
				(newState: DepartmentsState, department: Group) => newState.set(Number(department.id), department),
				state,
			)
		case DepartmentsTypes.UpdateDepartment.SUCCESS:
		case DepartmentsTypes.CreateDepartment.SUCCESS:
			return state.set(Number(action.payload.id), action.payload)
		case DepartmentsTypes.DeleteDepartment.SUCCESS:
			return state.delete(Number(action.requestPayload.id))
	}
	return state
}

export default departmentsReducer
